export const ExceptionLogsConstants= {
 
    GET_ExceptionLogs_REQUEST: 'GET_ExceptionLogs_REQUEST',
    GET_ExceptionLogs_SUCCESS: 'GET_ExceptionLogs_SUCCESS',
    GET_ExceptionLogs_FAILURE: 'GET_ExceptionLogs_FAILURE',
}